import React from "react";
import SymptomSelector from "./SymptomSelector";
import { triggers as Triggers } from "../../data/triggers";

import {
  newPhysicalSymptoms,
  newMentalSymptoms,
  lifestyleFactors,
} from "../../data/symptoms";
import LifestyleSelector from "./LifestyleSelector";

const getTimestamp = () => new Date().toISOString();

const MoodTracker = ({ entries, onChange, isVisible }) => {
  if (!isVisible) {
    return null;
  }

  const handleChange = (field, value) => {
    onChange({
      ...entries,
      [field]: value,
      Timestamp: entries.Timestamp || getTimestamp(),
    });
  };

  const getWarningsFromDetails = (details) => {
    if (!details || typeof details !== "string") return [];
    const text = details.toLowerCase();
    return Triggers.filter((entry) =>
      entry.sources?.some((keyword) => {
        if (!text.includes(keyword)) return false;
        // If this entry has exclusions, ensure none are present
        if (entry.exclusions) {
          return !entry.exclusions.some((ex) => text.includes(ex));
        }
        return true;
      })
    );
  };

  const detectedWarnings = getWarningsFromDetails(entries["Details"]);

  return (
    <div className="tw-px-4 tw-mb-2">
      <div className="tw-mb-6">
        <div className="tw-w-full">
          <label className="tw-block tw-mb-2 tw-w-full">Details</label>
          <p className="tw-color-gray-500 tw-text-sm tw-mb-2">
            What did you eat? (Describe the meal, portion size, servings, etc.)
          </p>
        </div>
        <textarea
          value={entries["Details"] || ""}
          onChange={(e) => handleChange("Details", e.target.value)}
          className="tw-w-full tw-border tw-rounded-lg tw-p-4 dark:tw-bg-black"
          rows={2}
        />

        {detectedWarnings.length > 0 && (
          <div className="tw-mb-4">
            {detectedWarnings.map((warn, idx) => (
              <div
                key={idx}
                className="tw-text-sm tw-text-yellow-700 tw-bg-yellow-50 tw-rounded-2xl tw-py-4 tw-px-6 tw-mt-3"
              >
                <p className="tw-font-semibold">⚠️ {warn.trigger} Trigger</p>
                <p className="tw-mt-1 tw-text-gray-700 dark:tw-text-gray-300">
                  Possible symptoms: {warn.symptoms.join(", ")}.
                </p>
                <p className="tw-mt-1 tw-text-gray-700 dark:tw-text-gray-300">
                  {warn.why}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>

      <SymptomSelector
        label="Mood Before Meal"
        categories={newMentalSymptoms}
        selected={entries["Mood Before Meal"] || []}
        setSelected={(val) => handleChange("Mood Before Meal", val)}
      />
      <SymptomSelector
        label="Mood After Meal"
        categories={newMentalSymptoms}
        selected={entries["Mood After Meal"] || []}
        setSelected={(val) => handleChange("Mood After Meal", val)}
      />
      <SymptomSelector
        label="Physical Symptoms"
        categories={newPhysicalSymptoms}
        selected={entries["Physical Symptoms"] || []}
        setSelected={(val) => handleChange("Physical Symptoms", val)}
      />
      <LifestyleSelector
        categories={lifestyleFactors}
        selected={entries["Lifestyle Factors"] || []}
        setSelected={(val) => handleChange("Lifestyle Factors", val)}
      />
    </div>
  );
};

export default MoodTracker;
